import React, { Component } from 'react';
import { observer } from 'mobx-react';

import DashboardState from 'js/stores/pages/AdminDashboardPage/DashboardState';

import LoadingSpinner from '../LoadingSpinner';
import DashPanel from '../DashPanel';
import Content from '../DashPanel/Content';
import Header from '../DashPanel/Header';
import DropMenu from '../DashPanel/DropMenu';
import Title from '../DashPanel/Title';

import RefreshButton from './RefreshButton';
import Dash from './Dash';
import Table from './Table';
import Label from './Label';
import Value from './Value';

@observer
export default class Dashboard extends Component {
  dashboard = DashboardState.create();

  constructor(props) {
    super(props);
    this.dashboard.load();
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Dashboard</Title>
        </Header>

        <Content>
          {this.dashboard.isLoading ? (
            <LoadingSpinner />
          ) : (
            <Dash>
              <RefreshButton title="Refresh main dashboard data" onClick={() => this.dashboard.load(true)} />

              <Table>
                <tbody>
                  <tr>
                    <Label>Users:</Label>
                    <Value>
                      {this.dashboard.num_users_human} ({this.dashboard.recent_users_human} in the last 24hr, {this.dashboard.recent_users_last_month} in the last month)
                    </Value>
                  </tr>

                  <tr>
                    <Label>Items:</Label>
                    <Value>
                      {this.dashboard.num_items_human} ({this.dashboard.recent_items_human} in the last 24hr)
                    </Value>
                  </tr>

                  <tr>
                    <Label>Tokens:</Label>
                    <Value>
                      {this.dashboard.num_tokens_human} ({this.dashboard.recent_tokens_human} in the last 24hr)
                    </Value>
                  </tr>

                  <tr>
                    <Label>Completed orders:</Label>
                    <Value>{this.dashboard.completed_orders_human}</Value>
                  </tr>

                  <tr>
                    <Label>Fees collected:</Label>
                    <Value>${this.dashboard.total_fees_collected_human}</Value>
                  </tr>

                  <tr>
                    <Label>Total transacted:</Label>
                    <Value>${this.dashboard.total_transacted_human}</Value>
                  </tr>

                  <tr>
                    <Label>Payouts pending:</Label>
                    <Value>
                      ${this.dashboard.payout_pending_human} (
                      {this.dashboard.num_pending
                        ? `${this.dashboard.num_pending_human} sale${this.dashboard.num_pending > 1 ? 's' : ''}`
                        : 'none'}
                      )
                    </Value>
                  </tr>

                  <tr>
                    <Label>Claimed bonus count:</Label>
                    <Value>{this.dashboard.claimed_bonus_count}</Value>
                  </tr>

                  <tr>
                    <Label>Transacted users without bonus count:</Label>
                    <Value>{this.dashboard.transacted_users_without_bonus_count}</Value>
                  </tr>

                  <tr>
                    <Label>Shared referrals count:</Label>
                    <Value>{this.dashboard.shared_referrals_count}</Value>
                  </tr>

                  <tr>
                    <Label>Transacted users with bonus count:</Label>
                    <Value>{this.dashboard.transacted_users_with_bonus_count}</Value>
                  </tr>

                  <tr>
                    <Label>Average transactions with bonus:</Label>
                    <Value>{this.dashboard.average_transactions_with_bonus}</Value>
                  </tr>

                  <tr>
                    <Label>Not used bonus count:</Label>
                    <Value>{this.dashboard.not_used_bonus_count}</Value>
                  </tr>

                </tbody>
              </Table>
            </Dash>
          )}
        </Content>
      </DashPanel>
    );
  }
}
